// Promo page for non-subscribers

import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { Layout } from '../components/Layout';

export function PromoPage() {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto text-center mt-8">
        <div className="bg-card border border-border rounded-xl p-8 hover:border-accent/50 transition-colors">
          <div className="flex justify-center mb-6">
            <img
              src="/images/logo-dark-short.png"
              alt="Diosc"
              className="h-16 w-auto"
            />
          </div>

          <h1 className="text-3xl font-bold mb-4 text-foreground">Welcome to Diosc!</h1>

          <p className="text-muted-foreground mb-8">
            It looks like you don't have an active subscription yet.
          </p>

          <div className="bg-accent/10 border border-accent/30 rounded-lg p-5 mb-8 text-left">
            <h3 className="text-lg font-semibold text-accent mb-2">What is Diosc?</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Diosc is an advanced AI assistant platform that helps you automate tasks,
              manage knowledge bases, and integrate with your favorite tools.
            </p>
          </div>

          <div className="space-y-5 mb-10">
            <div className="flex items-start text-left">
              <div className="w-8 h-8 bg-secondary rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                <Check className="w-4 h-4 text-accent" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground">Multiple AI Assistants</h4>
                <p className="text-sm text-muted-foreground">Create and manage multiple specialized assistants</p>
              </div>
            </div>

            <div className="flex items-start text-left">
              <div className="w-8 h-8 bg-secondary rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                <Check className="w-4 h-4 text-accent" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground">MCP Server Integration</h4>
                <p className="text-sm text-muted-foreground">Connect to external tools and services</p>
              </div>
            </div>

            <div className="flex items-start text-left">
              <div className="w-8 h-8 bg-secondary rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                <Check className="w-4 h-4 text-accent" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground">Knowledge Bases</h4>
                <p className="text-sm text-muted-foreground">Build custom knowledge repositories for your AI</p>
              </div>
            </div>
          </div>

          <a
            href="https://dioschub.com"
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-8 py-3 rounded-md hover:bg-primary/90 transition-all text-sm font-medium"
          >
            Get Started with Diosc
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </Layout>
  );
}
